import { UiBox } from "@smp/ui";
import { useMemo } from "react";

import { ControlsAuth } from "./controls_auth";
import { useStyles } from "./header_mock.css";

export const HeaderMock = () => {
  const classes = useStyles();

  return useMemo(
    () => (
      <div className={classes.header}>
        <UiBox flexGrow={1} />
        <ControlsAuth />
      </div>
    ),
    [classes],
  );
};
